import { useTranslation } from "react-i18next";
import { useState } from "react";
import { categories } from "@/mocks/categories";
import { categoryImages } from "@/mocks/categoryImages";

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState<string>("");

  const handleSelect = (link: string, id: string) => {
    setSelected(id);
    setOpen(false);
    window.open(link, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="relative w-full max-w-md mx-auto">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between gap-3 px-5 py-3.5 rounded-xl bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer text-left"
      >
        <span className="flex items-center gap-2 text-foreground-800 text-sm">
          <i className="ri-price-tag-3-line text-lg text-primary-500" />
          <span>{selected ? t(categories.find((c) => c.id === selected)?.nameKey ?? "") : t("categories.dropdownLabel")}</span>
        </span>
        <i className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div className="absolute z-40 mt-2 w-full max-h-96 overflow-y-auto rounded-xl bg-background-50 border border-background-200 shadow-sm py-1">
          {categories.map((c) => (
            <button
              key={c.id}
              onClick={() => handleSelect(c.link, c.id)}
              className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer text-left"
            >
              <span className="w-12 h-9 rounded-md overflow-hidden shrink-0">
                <img
                  src={categoryImages[c.id]}
                  alt={t(c.nameKey)}
                  className="w-full h-full object-cover object-top"
                />
              </span>
              <span className="flex-1 truncate text-left">{t(c.nameKey)}</span>
              <i className="ri-arrow-right-up-line text-base text-foreground-400" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}